import { css } from '@emotion/react';
import type { ButtonHTMLAttributes } from 'react';
import { forwardRef } from 'react';

import IconAddFilled from '~icons/carbon/add-filled';

import { theme } from '@adflow/frontend/ui-theme';

const styles = {
	addButton: css({
		'&[data-disabled=true]': css({
			color: theme.colors.action.disabledBackground,
			cursor: 'default',

			svg: css({
				color: theme.colors.action.disabledBackground,
			}),
			'svg:active': { filter: 'none' },
		}),
	}),
	icon: css({
		color: theme.colors.palettes.primary.main,
		width: 26,
		height: 26,
		'&:active': {
			filter: 'brightness(81%)',
		},
	}),
	smallIcon: css({
		width: 18,
		height: 18,
	}),
};

export const buttonIconAddStyles = styles;

export type ButtonIconAddProps = ButtonHTMLAttributes<HTMLButtonElement> & {
	small?: boolean;
};

export const ButtonIconAdd = forwardRef<HTMLButtonElement, ButtonIconAddProps>(
	function ButtonIconAddRender({ small = false, ...forwardedProps }, ref) {
		return (
			<button
				data-testid="button-icon-add"
				type="button"
				{...forwardedProps}
				ref={ref}
				css={styles.addButton}
			>
				<IconAddFilled
					css={[
						styles.icon,
						small && styles.smallIcon,
						{ pointerEvents: 'none' },
					]}
				/>
			</button>
		);
	}
);
